/* eslint-disable max-lines-per-function */
import { FieldBase } from '@/components/form';
import { InfoPopover } from '@/components/ui/info';
import { FixgehaltFields } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/FixgehaltFields/FixgehaltFields';

import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { FieldGroup, Toggle } from '@e2n/ui';
import {
  faClock,
  faMoneyBill,
  faSpinnerThird,
} from '@fortawesome/pro-regular-svg-icons';
import { CSSVariables, FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

export function Bezahlungsart() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <div className="flex gap-1 items-center">
          <h2 className="text-neutrals-900 text-xl font-bold leading-7">
            {ctx.getCurrentSubStep()?.title}
          </h2>
          <InfoPopover
            text={t(
              'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.info',
            )}
          />
        </div>
        <p className="text-neutrals-800 text-sm font-normal leading-5">
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.description',
          )}
        </p>
      </div>
      <FieldGroup>
        <form.AppField
          name="bezahlung.bezahlungsart.art"
          listeners={{
            onChange: () => {
              form.resetField('bezahlung.bezahlungsart.stundenlohn');
              form.resetField('bezahlung.bezahlungsart.monatsgehalt');
              form.resetField('bezahlung.bezahlungsart.tarifGruppe');
            },
          }}>
          {(field) => {
            return (
              <FieldBase>
                <div className="col-span-2 grid md:grid-cols-2 items-start gap-4">
                  <Toggle
                    pressed={field.state.value === 'fixgehalt'}
                    onPressedChange={() => field.setValue('fixgehalt')}
                    variant={'outline'}
                    className="flex items-center justify-start gap-2 p-4 h-auto">
                    <FontAwesomeIcon icon={faMoneyBill} />
                    <span className="text-neutrals-900 text-sm font-semibold leading-5">
                      {t(
                        'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.art.options.fixgehalt',
                      )}
                    </span>
                  </Toggle>
                  <Toggle
                    pressed={field.state.value === 'stunden'}
                    onPressedChange={() => field.setValue('stunden')}
                    variant={'outline'}
                    className="flex items-center justify-start gap-2 p-4 h-auto">
                    <FontAwesomeIcon icon={faClock} />
                    <span className="text-neutrals-900 text-sm font-semibold leading-5">
                      {t(
                        'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.art.options.stunden',
                      )}
                    </span>
                  </Toggle>
                </div>
              </FieldBase>
            );
          }}
        </form.AppField>
      </FieldGroup>
      <form.Subscribe
        selector={(state) => ({
          bezahlungsart: state.values.bezahlung.bezahlungsart,
        })}>
        {({ bezahlungsart }) =>
          bezahlungsart?.art === 'fixgehalt' && (
            <Suspense
              fallback={
                <div className="flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={faSpinnerThird}
                    size="2x"
                    spin
                    className="text-primary-blue-600"
                    style={
                      {
                        '--fa-secondary-color': '#D1D1D6',
                      } as React.CSSProperties & CSSVariables
                    }
                  />
                </div>
              }>
              <FixgehaltFields />
            </Suspense>
          )
        }
      </form.Subscribe>
    </div>
  );
}
